import React from 'react';
import { DefaultProfileIcon } from '../utilities/resources';
import DrawerBox from './DrawerBox';
import Img from './Img';
import HomeIcon from '../assets/images/home-grey.svg';
import EducationIcon from '../assets/images/graduate-icon.svg';
import ReadMore from './ReadMore';

function ExpertsBottomSheet({ id, name, profilePic, qualification, bio, location, visible, setVisible }) {

  return (
    <DrawerBox
      title={null}
      visible={visible}
      setVisible={setVisible}
      placement='bottom'
      height='240px'
      className='expertsBottomSheetDrawer'
      bodyStyle={{ padding: '0px 24px 24px 24px', marginTop: -25 }}
    >
      <div className='expertsBottomSheet'>
        <div className='expertsBottomSheetTopContent'>
          <figure>
            <Img src={profilePic} defaultSrc={DefaultProfileIcon} alt={name} />
          </figure>
          <div className='expertsBottomSheetContent'>
            <h5>{name}</h5>
            {qualification && (
              <p>
                <img src={EducationIcon} alt='' />
                {qualification}
              </p>
            )}
            {location && (
              <p>
                <img src={HomeIcon} alt='' />
                {location}
              </p>
            )}
          </div>
        </div>
        {bio && <ReadMore content={bio} charLimit={280} readMoreText='More' readLessText='Less' />}
      </div>
    </DrawerBox>
  );
}

export default ExpertsBottomSheet;
